import { render, staticRenderFns } from "./AppraisalForm.vue?vue&type=template&id=6852b3b0"
import script from "./AppraisalForm.vue?vue&type=script&lang=js"
export * from "./AppraisalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports